import { render } from "./basicPopup.vue?vue&type=template&id=3ce25a4c"
import script from "./basicPopup.vue?vue&type=script&lang=js"
export * from "./basicPopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/clients.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__